import { render, staticRenderFns } from "./GeneralDataSection.vue?vue&type=template&id=61197f1d&scoped=true&"
import script from "./GeneralDataSection.vue?vue&type=script&lang=js&"
export * from "./GeneralDataSection.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDataSection.vue?vue&type=style&index=0&id=61197f1d&prod&scoped=true&lang=css&"
import style1 from "./GeneralDataSection.vue?vue&type=style&index=1&id=61197f1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61197f1d",
  null
  
)

export default component.exports